module.exports = __webpack_public_path__ + "static/media/Lincoln.421ea37a.webp";